import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from 'App.context.js';
import usePoliceReportAlloggiatiConfigHook from './PoliceAlloggiati.hook';
import { Input } from 'antd'; // Usamos el Input de Ant Design
import Loading from 'Components/common/Loader/Loading.jsx';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import styles from './PoliceAlloggiati.styles.js';
import Colors from 'constants/Colors';

export default function PoliceAlloggiati() {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const { state, actions } = usePoliceReportAlloggiatiConfigHook();
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);

  useEffect(() => {
    if (!isConfigLoaded) {
      actions.loadPoliceReportConfig();
      setIsConfigLoaded(true);
    }
  }, [isConfigLoaded]);

  const saveAlloggiatiConfig = () => {
    state.platform = 'ita_allogiati';
    actions.onSaveAlloggiatiConfig();
  };

  return (
    <div>
      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.sesUser')}</b>
          <Input
            bordered={false}
            value={state.alloggiatiUser}
            onChange={e => actions.setField('alloggiatiUser', e.target.value.trim())}
            disabled={state.isLoading}
            style={{ backgroundColor: Colors.inputBg }}
          />
        </div>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.sesPass')}</b>
          <Input.Password
            bordered={false}
            value={state.alloggiatiPass}
            onChange={e => actions.setField('alloggiatiPass', e.target.value.trim())}
            disabled={state.isLoading}
            style={{ backgroundColor: Colors.inputBg }}
            visibilityToggle={actions.isAdmin()} // cant see info of field for non admin users
          />
        </div>
      </div>
      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{'WSKEY'}</b>
          <Input
            bordered={false}
            value={state.wskey}
            onChange={e => actions.setField('wskey', e.target.value.trim())}
            disabled={state.isLoading}
            style={{ backgroundColor: Colors.inputBg }}
          />
        </div>
      </div>
      <div style={styles.buttonContainer}>
        {state.isLoading && <Loading size={'small'} />}
        <AppButton
          text={translate('policeReport.save')}
          action={() => saveAlloggiatiConfig()}
          disabled={state.isLoading}
        />
      </div>
    </div>
  );
}
